module.exports = __webpack_public_path__ + "fepro/img/basketball.cc6e8767.png";